import { isEmpty } from 'lodash-es';

export function isObject(maybeObject: unknown) {
  return typeof maybeObject === 'object' && !Array.isArray(maybeObject) && maybeObject !== null;
}

/**
 * Type guard for a plain object (not null, not an array). Narrows `unknown` to
 * `Record<string, unknown>` so callers can read keys without a cast.
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isEmptyOrEmptyObject(object: unknown) {
  if (!isObject(object)) {
    return isEmpty(object);
  }

  return Object.keys(object as object).length === 0;
}
